'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNotLastBreakpoint = exports.buildMappingsByIndex = exports.findNextBreakpointByIndex = exports.findBreakpointByIndex = exports.findBreakpointIndex = exports.findBreakpointByName = undefined;

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var _errors = require('../errors');

var _breakpointMapping = require('./breakpointMapping');

var findBreakpointByName = exports.findBreakpointByName = (0, _ramda.curry)(function (breakpointMap, name) {
  return (0, _ramda.pipe)((0, _ramda.find)((0, _ramdaAdjunct.lensSatisfies)((0, _ramda.equals)(name), (0, _ramda.lensIndex)(0))), (0, _errors.throwWhenUndefined)((0, _errors.noBreakpointWithNameError)(name)), _ramda.last)(breakpointMap);
});

var findBreakpointIndex = exports.findBreakpointIndex = function findBreakpointIndex(breakpointMap, name) {
  return (0, _ramda.findIndex)((0, _ramdaAdjunct.lensSatisfies)((0, _ramda.equals)(name), (0, _ramda.lensIndex)(0)), breakpointMap);
};

var findBreakpointByIndex = exports.findBreakpointByIndex = (0, _ramda.curry)(function (breakpointMap, idx) {
  return (0, _ramda.pipe)((0, _ramda.flip)(_ramda.nth)(breakpointMap), (0, _errors.throwWhenUndefined)((0, _errors.noBreakpointAtIndexError)(idx)))(idx);
});

var findNextBreakpointByIndex = exports.findNextBreakpointByIndex = (0, _ramda.curry)(function (breakpointMap, idx) {
  return (0, _ramda.pipe)(_ramda.inc, findBreakpointByIndex(breakpointMap))(idx);
});

var buildMappingsByIndex = exports.buildMappingsByIndex = function buildMappingsByIndex(breakpointMap, values) {
  return (0, _ramdaAdjunct.reduceIndexed)(function (mappings, value, idx) {
    return (0, _ramda.pipe)(findBreakpointByIndex(breakpointMap), (0, _ramda.insert)(1, value), (0, _ramda.apply)(_breakpointMapping.createBreakpointMapping), (0, _ramdaAdjunct.appendFlipped)(mappings))(idx);
  }, [], values);
};

var isNotLastBreakpoint = exports.isNotLastBreakpoint = (0, _ramda.useWith)(_ramda.gt, [(0, _ramda.pipe)((0, _ramda.prop)('length'), _ramda.dec), _ramda.identity]);


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/utils/breakpointMap.js
// module id = 680
// module chunks = 168707334958949